import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FilesService } from '@core/services/files.service';
import { EImportSteps } from '@core/services/posthog.service';
import { environment } from '@env/environment';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ExportImportService {
  public emitExportEvent = new Subject<number>();
  public emitImportEvent = new Subject<{
    importId: string;
    importType: string;
    step: EImportSteps;
  }>();

  constructor(
    private readonly _httpClient: HttpClient,
    private readonly filesService: FilesService,
  ) {}

  public getErrorTranslationKey(error: string): string {
    const keyByErrorCode = {
      BAD_FILE: 'EXPORT_IMPORT.ERROR.BAD_FILE',
      BAD_DATA: 'EXPORT_IMPORT.ERROR.BAD_DATA',
      IMPORT_FAILED: 'EXPORT_IMPORT.ERROR.IMPORT_FAILED',
      REQUEST_ERROR: 'EXPORT_IMPORT.ERROR.REQUEST_ERROR',
    };

    return keyByErrorCode[error] ?? 'EXPORT_IMPORT.ERROR.UNKNOWN';
  }

  public export(): Observable<boolean> {
    const endpoint = `meeting/export`;
    const timeBeforeDowload = Date.now();
    return this.filesService.downloadFile(endpoint, 'silae').pipe(
      tap(() => {
        const timeAfterDowload = Date.now();
        this.emitExportEvent.next(timeAfterDowload - timeBeforeDowload);
      }),
    );
  }

  public importStarted(mode: 'replace' | 'add'): string {
    const importId = `${Date.now()}`;
    this.emitImportEvent.next({
      importId,
      importType: mode,
      step: EImportSteps.METHOD_SELECTED,
    });

    return importId;
  }

  public check(
    mode: 'replace' | 'add',
    formData: FormData,
    importId: string,
  ): Observable<{
    categoriesToImportById: { [id: string]: { isSystem: boolean } };
    questionsToImportById: { [id: string]: { isSystem: boolean } };
    templatesToImportById: { [id: string]: { isSystem: boolean } };
    nbQuestionsToCreate: number;
    nbTemplatesToCreate: number;
  }> {
    let url = mode === 'replace' ? 'file-replace-check' : 'file-add-check';

    return this._httpClient
      .post<{
        categoriesToImportById: { [id: string]: { isSystem: boolean } };
        questionsToImportById: { [id: string]: { isSystem: boolean } };
        templatesToImportById: { [id: string]: { isSystem: boolean } };
        nbQuestionsToCreate: number;
        nbTemplatesToCreate: number;
      }>(`${environment.API_URL}/meeting/import/${url}`, formData)
      .pipe(
        tap(() => {
          this.emitImportEvent.next({
            importId,
            importType: mode,
            step: EImportSteps.DOC_UPLOADED,
          });
        }),
      );
  }

  public import(
    mode: 'replace' | 'add',
    formData: FormData,
    importId: string,
  ): Observable<boolean> {
    const url = mode === 'replace' ? 'file-replace' : 'file-add';

    return this._httpClient
      .post<boolean>(`${environment.API_URL}/meeting/import/${url}`, formData)
      .pipe(
        tap(() => {
          this.emitImportEvent.next({
            importId,
            importType: mode,
            step: EImportSteps.IMPORT_COMPTED,
          });
        }),
      );
  }
}
